import { startingWithSpaceNotOnlyAlphabetsRegex } from 'Constants/regex'
import { INestedQuestionSet } from 'Models/BOB/ResponseModels/Life/QuestionSet'

const ecsFormObject: { form_fields: INestedQuestionSet[] } = {
  form_fields: [
    {
      max: undefined,
      name: 'Name of Account Holder',
      code: 'accountHolderName',
      dropdown: undefined,
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'String',
      hidden: false,
      range: false,
      values: {},
      regex: startingWithSpaceNotOnlyAlphabetsRegex,
    },
    {
      max: 14,
      name: 'Account Number',
      code: 'accountNumber',
      dropdown: undefined,
      cover_type: 'Text',
      min: 9,
      description: '',
      input_type: 'String',
      hidden: false,
      range: false,
      regex: /^\d+$/,
      values: {},
    },
    {
      max: undefined,
      name: 'Account Type',
      code: 'accountType',
      dropdown: {
        Current: 'Current',
        Savings: 'Savings',
      },
      cover_type: 'switch',
      min: undefined,
      description: '',
      input_type: 'Boolean',
      hidden: false,
      values: {
        Yes: [],
        No: [],
      },
    },
    {
      max: 11,
      name: 'IFSC Code',
      code: 'ifscCode',
      dropdown: undefined,
      cover_type: 'Text',
      min: 11,
      description: '',
      input_type: 'String',
      hidden: false,
      range: false,
      values: {},
    },
    {
      max: undefined,
      name: 'Bank Name',
      code: 'bank',
      dropdown: undefined,
      cover_type: 'Text',
      description: '',
      input_type: 'String',
      hidden: false,
      range: false,
      values: {},
    },
    {
      max: undefined,
      name: 'Bank Branch Name',
      code: 'branch',
      dropdown: undefined,
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'String',
      hidden: false,
      range: false,
      values: {},
    },
    // {
    //   max: undefined,
    //   name: 'MICR',
    //   code: 'micr',
    //   dropdown: undefined,
    //   cover_type: 'Text',
    //   min: undefined,
    //   description: 'Enter MICR',
    //   input_type: 'String',
    //   hidden: false,
    //   range: false,
    //   values: {},
    // },
  ],
}
export { ecsFormObject }
